<template>
	<router-link
		tag="a"
		:to="`/lista-productos/${item.category ? item.category.slug : ''}/${item.slug}-detail`"
		class="item"
		:class="{ 'item-horizontal': display == 'horizontal' }"
	>
		<div class="image" :style="'background-image:url(' + item.image.url + ')'"></div>

		<div class="data">
			<h2 class="title">{{ item.name }}</h2>
			<div class="data-items">

				<div class="data-item" v-if="item.dimensions">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="icon icon-tabler icon-tabler-dimensions"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						stroke-width="2"
						stroke="currentColor"
						fill="none"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
						<path d="M3 5h11"></path>
						<path d="M12 7l2 -2l-2 -2"></path>
						<path d="M5 3l-2 2l2 2"></path>
						<path d="M19 10v11"></path>
						<path d="M17 19l2 2l2 -2"></path>
						<path d="M21 12l-2 -2l-2 2"></path>
						<rect x="3" y="10" width="11" height="11" rx="2"></rect>
					</svg>
					{{ item.dimensions }}
				</div>
				<div class="data-item" v-if="item.capacity">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="icon icon-tabler icon-tabler-users"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						stroke-width="2"
						stroke="currentColor"
						fill="none"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
						<circle cx="9" cy="7" r="4"></circle>
						<path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
						<path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
						<path d="M21 21v-2a4 4 0 0 0 -3 -3.85"></path>
					</svg>
					{{ item.capacity }}
				</div>
				<div class="data-item" v-if="item.waterTank">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="icon icon-tabler icon-tabler-droplet"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						stroke-width="2"
						stroke="currentColor"
						fill="none"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
						<path d="M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"></path>
					</svg>
					{{ item.waterTank }}
				</div>
			</div>
			<div class="price mt-4" v-if="item.salable">
				<span class="currency mr-1">U$S</span>
				<span class="amount">{{ item.price }}</span>
				<small class="ml-1">IVA INC</small>
			</div>
			<div class="mb-2" v-if="item.featured" v-html="item.featuredDetail"></div>
			<button class="btn btn-block btn-primary mt-3 ">
				Más info
			</button>
		</div>
	</router-link>
</template>
<script>
export default {
	props: ["item", "display"]
}
</script>
<style scoped>
.item {
	display: flex;
	flex-direction: column;
	position: relative;
	margin: 8px;
	padding: 0;
	text-align: center;
	color: #000;
	transition: all 0.4s ease-in-out;
	background-color: #fff;
	border-radius: 10px;
	
	overflow: hidden;
	box-shadow: 0px 4px 10px #0000001a;
}
.item:hover {
	/* background-color: #f8f8f8; */
	box-shadow: 0px 10px 10px #00000045;
}

.item .title {
	font-weight: 600;
    font-size: 1.1rem;
    line-height: 1.1;
    z-index: 10;
    height: 55px;
}
.item .image {
	width: 100%;
	margin: auto;
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
	aspect-ratio: 16 / 12;
}
.item .data {
	position: relative;
	flex-grow: 1;
	padding: 30px 20px;
	aspect-ratio: 16 / 12;
	text-align: left;
	display: flex;
	flex-direction: column;
}
.item .data .data-items {
	flex-grow: 1;
}
.item .data .data-item {
	display: flex;
	padding: 4px;
	align-items: center;
	font-size: 12px;
}
.item .data .data-item svg {
	width: 18px;
	margin-right: 8px;
}

.item .data .btn {
	margin: auto;
}
.item .price {
	font-size: 15px;

	line-height: 20px;
}
.item .price .currency {
	font-size: 14px;
	font-weight: 500;
}
.item .price .amount {
	font-size: 18px;
	font-weight: 600;
}

.badge-primary {
	width: 90px;
	background-color: var(--primary-color);
	border-radius: 20px;
	font-size: 10px;
	font-weight: 500;
	padding: 6px;
	position: absolute;
	top: -20px;
	left: calc(50% - 45px);
}

.item.item-horizontal {
	flex-direction: row;
	align-items: center;
}
.item.item-horizontal .image {
	padding-bottom: 30%;
}
.item.item-horizontal .data {
	text-align: left;
}
.item.item-horizontal .data .btn {
	margin: inherit;
}
</style>
